import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';

export default class Explanation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popoverOpen: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const { popoverOpen } = this.state;
    this.setState({ popoverOpen: !popoverOpen });
  }

  render() {
    const { popoverOpen } = this.state;
    const { text, type } = this.props;
    return (
      <React.Fragment>
        {type == 'explanation' && (
          <a
            className="question_help"
            onClick={text ? this.toggle : ''}
            id="PopoverEC"
            disabled={!text}
          >
            {text ? (
              <i className="icon_c_xl icon_explanation" />
            ) : (
              <i
                className="icon_c_xl icon_explanation_dis"
              />
            )}
          </a>
        )}
        {type == 'clarification' && (
          <a
            className="question_help"
            onClick={this.toggle}
            id="PopoverEC"
            disabled={!text}
          >
            {text ? (
              <i className="icon_c_xl icon_explanation" />
            ) : (
              <i
                className="icon_c_xl icon_explanation_dis"
              />
            )}
          </a>
        )}
        <Popover
          placement="bottom"
          isOpen={popoverOpen}
          target="PopoverEC"
          toggle={this.toggle}
        >
          <PopoverHeader>
            <FormattedMessage id={`passing_${type}`} />
          </PopoverHeader>
          <PopoverBody><span dangerouslySetInnerHTML={{ __html: text }}></span></PopoverBody>
        </Popover>
      </React.Fragment>
    );
  }
}

Explanation.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/_Lessons/Passing/_explanation.js